<template lang='pug'>
  .Extern.container
    .Bln-head
      .Bln-head-img
        img(src='@/assets/bln-assets/logo.png')
      .Bln-head-hdline
        h2 Behr Lachmann Neixler & Partner GbR ist zum Jahresende 2018 aufgelöst
    .Extern-text
      p Sehr geehrte Mandantinnen und Mandanten,
      p auch Erfolgsgeschichten sind endlich.
      p Wir haben unsere berufliche Zusammenarbeit zum Ende des Jahres 2018 beendet, die Sozietät BLN & Partner GbR aufgelöst und den gemeinsamen Kanzleisitz in der Englerallee 19, 14195 Berlin aufgegeben.
      p Seit 01. Januar 2019 erreichen Sie uns unter folgenden Adressen und Kontaktdaten:

    .Extern-content
      .Extern-content-wrapper
        .Extern-content-empty-item
          .Extern-content-details
            .Extern-content-image-wrapper
              img(src='@/assets/bln-assets/person_behr.jpg')
            .Extern-content-description-wrapper
              h4 Rechtsanwalt, Notar und Wirtschaftsprüfer Ulrich Behr
              p.Extern-content-description c/o Buse Heberer Fromm PartG mbB,
                <br> Kurfürstendamm 237, 10719 Berlin
                <br> Telefon: (030) 327942 – 0
                <br> E-Mail: <a href="mailto:behr@bln-partner.de">behr@bln-partner.de</a> und <a href="mailto:wolter@bln-partner.de">wolter@bln-partner.de</a>

        .Extern-content-empty-item
          .Extern-content-details
            .Extern-content-image-wrapper
              img(src='@/assets/bln-assets/person_lachmann.jpg')
            .Extern-content-description-wrapper
              h4 Rechtsanwältin und Notarin Ulrike Lachmann
              p.Extern-content-description hat ihre berufliche Tätigkeit beendet.

        .Extern-content-empty-item
          .Extern-content-details
            .Extern-content-image-wrapper
              img(src='@/assets/bln-assets/person_neixler.jpg')
            .Extern-content-description-wrapper
              h4 Rechtsanwalt und Notar Robert Neixler
              p.Extern-content-description hat seine berufliche Tätigkeit beendet.

        router-link.Extern-content-item( :to="{ name: 'Startseite' }" tag='a')
          .Extern-content-details
            .Extern-content-image-wrapper
              img(src='@/assets/bln-assets/person_schommer.jpg')
            .Extern-content-description-wrapper
              h4 Rechtsanwalt Christoph Schommer
              p.Extern-content-description Albestraße 21, 12159 Berlin
                <br /> Telefon: (030) 74 75 10 10
                <br /> Telefax: (030) 74 75 10 44
                <br /> E-Mail: <a href="mailto:schommer@bln-partner.de">schommer@bln-partner.de</a>
                <br /> www.ra-schommer.de

        a.Extern-content-item(href='https://www.gerchel-wolff.de' target='_blank')
          .Extern-content-details
            .Extern-content-image-wrapper
              img(src='@/assets/bln-assets/person_gerchel.jpg')
            .Extern-content-description-wrapper
              h4 Rechtsanwalt Thomas Gerchel
              p.Extern-content-description Lützowstraße 33 – 36, 10785 Berlin
                <br /> c/o Rechtsanwälte Wiese & Schlichting
                <br> Telefon: (030) 74 75 10 60
                <br> Telefax: (030) 74 75 10 44
                <br> E-Mail: <a href="mailto:gerchel@bln-partner.de">gerchel@bln-partner.de</a>
                <br>
                a(href="https://www.gerchel-wolff.de" target="_blank") www.gerchel-wolff.de

        .Extern-content-empty-item
          .Extern-content-details
            .Extern-content-image-wrapper
              img(src='@/assets/bln-assets/person_claussen.jpg')
            .Extern-content-description-wrapper
              h4 Rechtsanwalt Axel Claußen
              p.Extern-content-description Lützowstraße 33 – 36, 10785 Berlin
                <br /> c/o Rechtsanwälte Wiese & Schlichting
                <br /> Telefon: (030) 590 09 09 0
                <br /> Telefax: (030) 590 09 09 10
                <br /> E-Mail: <a href="mailto:a.claussen@outlook.com">a.claussen@outlook.com</a>
</template>

<script>
export default {
  name: 'NeueAdressen'
}
</script>

<style lang='stylus' scoped>
.Extern {
  background-color $bln-background
}

.Bln-head {
  &-img {
    padding-top 3em
    padding-bottom 3em

    img {
      max-width 90vw
    }
  }

  &-hdline {
    h2 {
      color black
    }
  }
}

.Extern-text {
  padding 2em
  margin-top 1em
  margin-left auto
  margin-right auto
  width 60%
  text-align left

  +below('l') {
    width 100%
  }
}

.Extern-content {
  padding 2em
  margin-top 1em

  +below('l') {
    padding 1em
    margin-top 0
  }

  +below('s') {
    padding 0
  }

  &-wrapper {
    display flex
    flex-direction column
    justify-content center
    max-width 1000px
    margin auto

    +below('m') {
      flex-wrap wrap
    }
  }

  &-details {
    display flex
    flex-direction row
    align-items center
    justify-content flex-start

    +below('m') {
      flex-direction column
      justify-content center
      margin auto
    }
  }

  &-image-wrapper {
    margin 0 2em

    img {
      max-width 200px
      border-radius 5%
    }
  }

  &-empty-item {
    padding 2em 3em
    margin-bottom 1em

    background-color #f0ad4e
    border-radius 5px
    box-shadow 2px 2px 5px 0px #555

    color $secondary-text

    +below('m') {
      padding 1em
      margin 1em auto
      max-width 500px
      width 100%
    }

    &:last-child {
      margin-bottom 0
    }

    &:hover {
      background-color #ffbe61
      box-shadow 3px 3px 5px 0px #555
      text-decoration none
    }
  }

  &-item {
    padding 2em 3em
    margin-bottom 1em

    background-color #f0ad4e
    border-radius 5px
    box-shadow 2px 2px 5px 0px #555
    transition all .5s

    color $secondary-text

    +below('m') {
      padding 1em
      margin 1em auto
      max-width 500px
      width 100%
    }

    &:last-child {
      margin-bottom 0
    }

    &:hover {
      background-color #ffbe61
      box-shadow 3px 3px 5px 0px #555
      cursor pointer
      text-decoration none
    }
  }

  &-description {
    margin 1em 0
    font-size 14px
    text-align left

    &-wrapper {
      display flex
      flex-direction column
      justify-content center
      align-items flex-start
      margin 0 1em
      text-align left

      +below('m') {
        margin-top 1em
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/bln-content/NeueAdressen.vue